import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { RefreshCw, Zap, Battery, Rocket, Cpu, TrendingDown } from 'lucide-react';
export function FpgaWinsSlide() {
  const benefits = [{
    icon: RefreshCw,
    title: 'Reconfigurable',
    desc: 'Update hardware logic in milliseconds to support new models.'
  }, {
    icon: Zap,
    title: 'Low Latency',
    desc: 'Deterministic performance ideal for real-time inference.'
  }, {
    icon: Battery,
    title: 'Power Efficient',
    desc: 'Significantly better performance-per-watt than GPUs.'
  }, {
    icon: Rocket,
    title: 'Fast Time-to-Market',
    desc: 'Deploy custom hardware logic immediately. No fab wait times.'
  }, {
    icon: Cpu,
    title: 'Adaptable',
    desc: 'Reprogram for new architectures (Mamba, RWKV, SSMs) and evolving Transformer variants without hardware replacement.'
  }, {
    icon: TrendingDown,
    title: 'Lower NRE',
    desc: 'Zero fabrication costs. Pay only for the chips you use.'
  }];
  return <SlideLayout slideNumber={8} totalSlides={20} title="The Solution" data-id="element-262">
      <div className="w-full h-full flex flex-col" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="text-center mb-5" data-id="element-264">
          <h2 className="text-5xl md:text-6xl font-bold mb-2" data-id="element-265">
            Why <span className="text-brand-primary" data-id="element-266">FPGAs</span> Win
          </h2>
          <p className="text-2xl text-brand-muted" data-id="element-267">
            The only hardware that combines the efficiency of ASICs with the
            flexibility of GPUs.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1" data-id="element-268">
          {benefits.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1 + 0.3
        }} className="bg-brand-surface border border-brand-primary/20 p-6 rounded-xl hover:border-brand-primary hover:shadow-[0_0_30px_-10px_rgba(45,212,191,0.3)] transition-all duration-300 flex flex-col justify-center" data-id="element-269">
              <div className="mb-3 p-3 bg-brand-primary/10 w-fit rounded-lg text-brand-primary" data-id="element-270">
                <item.icon size={36} data-id="element-271" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-272">
                {item.title}
              </h3>
              <p className="text-brand-muted text-xl leading-snug" data-id="element-273">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </SlideLayout>;
}